import axios from 'axios';
import { getApiBaseUrl, setupAxiosAuth } from '../utils/urlConfig';

const API_BASE_URL = `${getApiBaseUrl()}/admin`;

const setupRequest = () => {
  setupAxiosAuth(axios);
};

export const fetchMentors = async (page = 1, limit = 10, search = '') => {
  try {
    setupRequest();
    const response = await axios.get(`${API_BASE_URL}/mentors`, {
      params: { page, limit, search },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching mentors:', error);
    throw error;
  }
};

export const fetchMentorBatches = async (mentorId) => {
  try {
    setupRequest();
    const response = await axios.get(`${API_BASE_URL}/mentors/${mentorId}/batches`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching batches for mentor ${mentorId}:`, error);
    throw error;
  }
};

export const assignBatchToMentor = async (mentorId, batchId) => {
  try {
    setupRequest();
    const response = await axios.post(
      `${API_BASE_URL}/mentors/${mentorId}/batches/${batchId}`
    );
    return response.data;
  } catch (error) {
    console.error(`Error assigning batch ${batchId} to mentor ${mentorId}:`, error);
    throw error;
  }
};

export const removeBatchFromMentor = async (mentorId, batchId) => {
  try {
    setupRequest();
    const response = await axios.delete(
      `${API_BASE_URL}/mentors/${mentorId}/batches/${batchId}`
    );
    return response.data;
  } catch (error) {
    console.error(`Error removing batch ${batchId} from mentor ${mentorId}:`, error);
    throw error;
  }
};

export const fetchMentorHierarchy = async () => {
  try {
    setupRequest();
    const response = await axios.get(`${API_BASE_URL}/mentors/hierarchy`);
    return response.data;
  } catch (error) {
    console.error('Error fetching mentor hierarchy:', error);
    throw error;
  }
};

// changes: { hierarchy?, supervisorId? } — supervisorId: null clears it.
export const updateMentorHierarchy = async (mentorId, changes) => {
  try {
    setupRequest();
    const response = await axios.patch(
      `${API_BASE_URL}/mentors/${mentorId}/hierarchy`,
      changes
    );
    return response.data;
  } catch (error) {
    console.error(`Error updating hierarchy for mentor ${mentorId}:`, error);
    throw error;
  }
};

// Hands hierarchy control for this mentor back to the Testpress sync.
export const unlockMentorHierarchy = async (mentorId) => {
  try {
    setupRequest();
    const response = await axios.post(
      `${API_BASE_URL}/mentors/${mentorId}/hierarchy/unlock`
    );
    return response.data;
  } catch (error) {
    console.error(`Error unlocking hierarchy for mentor ${mentorId}:`, error);
    throw error;
  }
};

export const cleanupPartialBatchesForAllMentors = async ({
  search = '',
  mentorIds = null,
  dryRun = false,
  password = '',
} = {}) => {
  try {
    setupRequest();
    const body = { dryRun };
    if (mentorIds) body.mentorIds = mentorIds;
    else if (search) body.search = search;
    if (!dryRun) body.password = password;
    const response = await axios.post(
      `${API_BASE_URL}/mentors/cleanup-partial-batches`,
      body
    );
    return response.data;
  } catch (error) {
    console.error('Error cleaning up partial batches for all mentors:', error);
    throw error;
  }
};
